import { ColorItemSchemeClass } from '../theme.const';

interface SpaceFilterLease {
  space_id: number;
}

export interface SpaceFilter {
  id: number;
  floor: string;
  suite: string;
  lease?: SpaceFilterLease;
}

/** Filters interface and the aggregated space area with it's respective uom */
export interface ToolbarFilterOption {
  id: number;
  /** label to display on the filter */
  label: string;
  /** Value aggregation for the filter */
  spaceArea: number;
  /** uom for the aggregation */
  spaceAreaUOM: string;
  /** color class for the filter */
  class: ColorItemSchemeClass;
  /** spaces (suite_id) that fall in this bucket */
  spaces: SpaceFilter[];
  /** key is for translation labels  */
  key: string;
  spacePercent?: number;
}
/** Array of options with FilterView enum as key and a string as a value */
export type ToolBarViewOption = Option<FilterView, string>;

/**
 * Simple structured interface that is used to hold selected filter values
 */
export interface Filters {
  [value: string]: boolean;
}

/** Existing Filter View keys */
export enum FilterView {
  Lease = 'lease',
  LeaseYear = 'leaseYear',
  Industry = 'industry',
  Agency = 'agency',
  Usage = 'usage',
  Occupiers = 'occupier',
}

/**
 * Simple filter state interface.
 */
export interface FilterState {
  /** Holds selected view */
  viewBy: FilterView;
  /** Holds current filters */
  selectedFilters: Filters;
  /** current filters displayed */
  filterOptions: ToolbarFilterOption[];
}

/** Simple and generic key/value interface */
export interface Option<K, T> {
  key: K;
  value: T;
}

export interface FilterDataRequest {
  view: FilterView;
  localeId?: number;
  propertyType?: string;
  isRemoveUnaccountedEnabled?: boolean;
}
